<template>
	<div id="import-preset-modals">
		<div id="import-preset-modal" class="modal-new hidden">
			<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
				<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
				<path d="M0 0h24v24H0z" fill="none" />
			</svg>
			<span class="title">Import a Preset</span>
			<p class="description">Please select the preset to import</p>

			<input @change.stop="presetSelected($event)" type="file" id="import-preset-input" name="preset" />

			<div class="buttons-continer">
				<button @click="openImport" type="button" class="modal-btn --primary" data-modal-action="browse-preset-for-import">
					Browse for Presets
				</button>
			</div>
		</div>

		<div id="import-preset-2-modal" class="modal-new hidden">
			<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
				<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
				<path d="M0 0h24v24H0z" fill="none" />
			</svg>
			<span class="title">Import a Preset</span>

			<div class="dropdown-component control-selector">
				<div class="control-selector__label-container" :class="{ '--disabled': presets.length == 0 }">
					<span class="selected-control-name">{{ presetFolder.id ? presetFolder.name : "Select folder" }}</span>
					<i class="material-icons">expand_more</i>
				</div>

				<div class="control-selector__items-container" style="display: none;">
					<span
						v-for="presetFolder in presets"
						@click="onFolderSelection(presetFolder)"
						:key="presetFolder.id"
						:data-index="presetFolder.id"
						:data-name="presetFolder.name"
					>
						{{ presetFolder.name }}
					</span>
				</div>

				<i @click="onAddingNewFolder" id="btn_modal-add-folder-import-preset" class="material-icons" data-tippy-content="New Folder">
					add_circle_outline
				</i>
			</div>

			<input type="text" v-model.trim="folderName" name="folder" placeholder="Folder" style="display: none" class="regex-check" />
			<input type="text" v-model.trim="presetName" name="name" placeholder="Name" class="regex-check" />
			<div class="buttons-continer">
				<button @click="importPreset" type="button" class="modal-btn --primary">Save</button>
				<button type="button" class="modal-btn --cancel" data-modal-action="close-modal">Cancel</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import SparkMD5 from "spark-md5";

export default {
	data() {
		return {
			blocksData: null,
			folderName: "",
			presetName: "",
		};
	},
	computed: {
		...mapGetters("UserFiles", ["presets", "presetFolder"]),
	},
	methods: {
		openImport() {
			window.lutify.activeModal.find("#import-preset-input").trigger("click");
		},
		presetSelected(e) {
			let fr = new FileReader();
			fr.onload = () => {
				if (e.target.files[0].type !== "application/json") {
					window.$(e.target).val("");
					window.UI.hideModal();
					window.UI.showModal(window.UI.modals.presets.fileSupport.el);
					return;
				}

				let md5 = JSON.parse(fr.result).md5;
				this.blocksData = JSON.parse(fr.result).blocks;
				this.presetName = JSON.parse(fr.result).name;

				if (md5 !== SparkMD5.hash(JSON.stringify(this.blocksData))) {
					window.$(e.target).val("");
					window.UI.hideModal();
					window.UI.showModal(window.UI.modals.presets.invalidFile.el);
					return;
				}

				window.UI.hideModal();
				window.UI.modals.presets.import2.el.find('input[name="folder"]').hide();
				window.UI.showModal(window.UI.modals.presets.import2.el);
				window.$(e.target).val("");
			};

			fr.readAsText(e.target.files[0]);
		},

		onFolderSelection(folder) {
			this.$store.dispatch("UserFiles/selectPresetFolder", folder.id);
		},

		async importPreset() {
			window.UI.hideModal();

			let presetData = {};
			if (this.presetFolder.id && this.folderName == "") presetData.folder_id = this.presetFolder.id;
			else {
				if (this.folderName == "") this.folderName = "New Folder";
				presetData.folderName = this.folderName;
			}

			if (this.presetName == "") this.presetName = `New Preset.${Date.now()}`;
			else this.presetName = `${this.presetName}.${Date.now()}`;
			presetData.presetName = this.presetName;

			presetData.file = new File([JSON.stringify(this.blocksData)], presetData.presetName + ".json", {
				type: "application/json",
			});

			await this.$store.dispatch("UserFiles/postPreset", presetData).then(response => {
				window.presetsStore.setItem(response.id, this.blocksData);
				window.UI.message.activate(`Preset Imported Successfully`);
                this.$store.dispatch('UI/setAnimationForAddingPreset');
            });

			this.$store.dispatch("UserFiles/fetchPresets");

			this.folderName = "";
			this.presetName = "";
		},

		onAddingNewFolder() {
			window.UI.modals.presets.import2.el.find('input[name="folder"]').show();
			window.UI.modals.presets.import2.el.find('input[name="folder"]').focus();
		},
	},
};
</script>

<style></style>
